if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement /*, fromIndex */ ) {
        'use strict';
        if (this == null) {
            throw new TypeError();
        }
        var t = Object(this);
        var len = t.length >>> 0;
        if (len === 0) {
            return -1;
        }
        var n = 0;
        if (arguments.length > 1) {
            n = Number(arguments[1]);
            if (n != n) { // shortcut for verifying if it's NaN
                n = 0;
            } else if (n != 0 && n != Infinity && n != -Infinity) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
        }
        if (n >= len) {
            return -1;
        }
        var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
        for (; k < len; k++) {
            if (k in t && t[k] === searchElement) {
                return k;
            }
        }
        return -1;
    };
}

// Date.prototype.toISOString polyfill for IE8
// from https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Date/toISOString
// used in angular ui date directive
if (!Date.prototype.toISOString ) {
    ( function() {
        function pad(number) {
            var r = String(number);
            if ( r.length === 1 ) {
                r = '0' + r;
            }
            return r;
        }

        Date.prototype.toISOString = function() {
            return this.getUTCFullYear()
                + '-' + pad( this.getUTCMonth() + 1 )
                + '-' + pad( this.getUTCDate() )
                + 'T' + pad( this.getUTCHours() )
                + ':' + pad( this.getUTCMinutes() )
                + ':' + pad( this.getUTCSeconds() )
                + '.' + String( (this.getUTCMilliseconds()/1000).toFixed(3) ).slice( 2, 5 )
                + 'Z';
        };

    }() );
}

String.prototype.format = function( ){
    var pattern = /\{\d+\}/g;
    var args = arguments;
    return this.replace( pattern, function( capture ){
       return args[ capture.match(/\d+/) ];
    });
};

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
        if(typeof searchString === 'undefined'){
            return false;
        }
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

if (window.angular && !angular.merge) {
  angular.merge = (function mergePollyfill() {
    function setHashKey(obj, h) {
      if (h) {
        obj.$$hashKey = h;
      } else {
        delete obj.$$hashKey;
      }
    }

    function baseExtend(dst, objs, deep) {
      var h = dst.$$hashKey;

      for (var i = 0, ii = objs.length; i < ii; ++i) {
        var obj = objs[i];
        if (!angular.isObject(obj) && !angular.isFunction(obj)) {continue;}
        var keys = Object.keys(obj);
        for (var j = 0, jj = keys.length; j < jj; j++) {
          var key = keys[j];
          var src = obj[key];

          if (deep && angular.isObject(src)) {
            if (angular.isDate(src)) {
              dst[key] = new Date(src.valueOf());
            } else {
              if (!angular.isObject(dst[key])) {dst[key] = angular.isArray(src) ? [] : {};}
              baseExtend(dst[key], [src], true);
            }
          } else {
            dst[key] = src;
          }
        }
      }

      setHashKey(dst, h);
      return dst;
    }

    return function merge(dst) {
      return baseExtend(dst, [].slice.call(arguments, 1), true);
    };
  }());
}

/**
 * This is currently not in a reusable format, work in progress.....
 * Generates a jqPlot Pie Chart
 * @param showLegend {boolean} passed as the expression
 */
window.sortByValue = function(obj) {
    var sortable = [], key;
    for (key in obj)
        {sortable.push([key, obj[key]]);}
    sortable.sort(function(a, b) {return b[1] - a[1];});

    var returnObj = {};
    for(key in sortable)
        {returnObj[sortable[key][0]] = sortable[key][1];}
    return returnObj;
};

/**
 * Temp replacement for AngularJS v0.10's angular.Object.size()
 * @param  {[type]} obj [description]
 * @return {[type]}     [description]
 */
window.objectSize = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {size++;}
    }
    return size;
};

window.isDecimal = function(input){
    var pattern = /^\d+([,]\d+)*([.]\d+)*$/;
    return pattern.test($.trim(input));
};

window.getBrowserDetails = function(){
    var browserDetails = {};
    var nAgt = window.navigator.userAgent;
    var browserName = window.navigator.appName;
    var fullVersion = '' + parseFloat(window.navigator.appVersion);
    var majorVersion = parseInt(window.navigator.appVersion);
    var nameOffset, verOffset, ix;
    var OSName = 'Unknown OS';
    var ActiveXObject = window.ActiveXObject;
    function getFlashVersion() {
        // ie
        try {
            try {
                // avoid fp6 minor version lookup issues
                // see: http://blog.deconcept.com/2006/01/11/getvariable-setvariable-crash-internet-explorer-flash-6/
                var axo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.6');
                try {
                    axo.AllowScriptAccess = 'always';
                } catch (e) {
                    return '6,0,0';
                }
            } catch (e) {}
            return new ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version').replace(/\D+/g, ',').match(/^,?(.+),?$/)[1];
            // other browsers
        } catch (e) {
            try {
                if (navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
                    return (navigator.plugins['Shockwave Flash 2.0'] || navigator.plugins['Shockwave Flash']).description.replace(/\D+/g, ',').match(/^,?(.+),?$/)[1];
                }
            } catch (e) {}
        }
        return '0,0,0';
    }

    if (window.navigator.appVersion.indexOf('Win') !== -1) {OSName = 'Windows';}
    if (window.navigator.appVersion.indexOf('Mac') !== -1) {OSName = 'MacOS';}
    if (window.navigator.appVersion.indexOf('X11') !== -1) {OSName = 'UNIX';}
    if (window.navigator.appVersion.indexOf('Linux') !== -1) {OSName = 'Linux';}

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        browserName = 'Opera';
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) !== -1)
            {fullVersion = nAgt.substring(verOffset + 8);}
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        browserName = 'Microsoft Internet Explorer';
        fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        browserName = 'Chrome';
        fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        browserName = 'Safari';
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) !== -1)
            {fullVersion = nAgt.substring(verOffset + 8);}
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        browserName = 'Firefox';
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) !== -1)
        {fullVersion = fullVersion.substring(0, ix);}
    if ((ix = fullVersion.indexOf(' ')) !== -1)
        {fullVersion = fullVersion.substring(0, ix);}

    majorVersion = parseInt('' + fullVersion);
    if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion);
    }

    browserDetails.getBrowser = function() {
        return browserName;
    };

    browserDetails.getBrowserVersion = function() {
        return fullVersion;
    };

    browserDetails.getOSVersion = function() {
        return OSName;
    };

    browserDetails.getFlashVersion = function() {
        return getFlashVersion();
    };

    (function(){
        var M= nAgt.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        browserDetails.msie = /trident/i.test(M[1]);
    }());

    return browserDetails;
};